import { Pipe, PipeTransform, inject } from '@angular/core';
import { FormatService } from 'src/app/_core/format.service';

@Pipe({
  name: 'agrFormat',
  standalone: false
})
export class FormatPipe implements PipeTransform {
  private formatService = inject(FormatService);

  transform(value: number | string | Date, args?: string): any {
    return this.formatService.format(value, args);
  }
}
